import { GET_INFO, GET_USER, GET_TOKEN, GET_LOADERS ,GET_REGISTER_OPTIONS } from '../types'

export const getters = {
  // return the latest broadcast message
  [GET_INFO] (state) {
    return state.message
  },
  // return the current user state
  [GET_USER] (state) {
    return state.user
  },
  // return the token from local storage
  [GET_TOKEN] (state) {
    return state.user.token
  },
  // all loaders
  [GET_LOADERS] (state) {
    return state.loaders
  },
  // REGISTER OPTIONS
  [GET_REGISTER_OPTIONS] (state) {
    return state.registerOptions
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js